import { BModal } from 'bootstrap-vue'
import util from '@/util'
import mensagens from '@/util/mensagens'
import spinnerProcessando from '@/components/layout/spinnerProcessamento/SpinnerProcessamento.vue'
import { mapActions, mapGetters } from 'vuex'
import constants from '@/util/constants'

export default {
  name: 'detalhe-adicional',
  components: {
    'b-modal': BModal,
    spinnerProcessando
  },
  props: {
    produto: {
      type: Object
    }
  },
  computed: {
    ...mapGetters('carrinho', ['obterTotalItensCarrinho', 'possuiItensCarrinho', 'itensCarrinho']),
    obterTituloModal () {
      const produto = this.produto.nome ?? ''
      return `Adicional de ${produto}`
    },
    planoSugerido () {
      if (!util.valorEhNulo(this.produto) && !util.valorEhNulo(this.produto.planos)) {
        return this.produto.planos.find(plano => plano.sugerido === true)
      }
      return null
    }
  },
  data: () => {
    return {
      formulario: {
        aceite_termos: false
      },
      planoSelecionado: null,
      retorno: {
        sucesso: false,
        mensagem: '',
        listaDeErros: [],
        listaDados: {}
      },
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      },
      duplaChecagem: false,
      confirmou: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.planoSelecionado = this.planoSugerido
    })

    if (this.obterTotalItensCarrinho > 0 && this.itensCarrinho.filter(r => r.produto.id === constants.idProdutoMirt).length > 0) {
      this.duplaChecagem = true
    }
  },
  methods: {
    ...mapActions('carrinho', [
      'ActionDefinirDadosCarrinho',
      'ActionAdicionarItemCarrinho',
      'ActionLimparDadosCarrinho'
    ]),
    async adicionar () {
      if (this.obterTotalItensCarrinho > 0 && this.itensCarrinho.filter(r => r.produto.id === constants.idProdutoMirt).length > 0) {
        this.duplaChecagem = false
        this.ActionLimparDadosCarrinho()
      }

      const validacaoOk = this.validarDadosFormulario()
      if (validacaoOk) {
        this.$router.push({ name: 'carrinho' })
        await this.efetuarAceiteContrato(this.planoSelecionado)
      }
    },
    temIlimitado (plano) {
      const resultado = plano.item_planos.filter((item) => {
        return item.ilimitado
      })

      if (resultado.length) {
        return true
      }

      return false
    },
    adicionarItemCarrinho (plano) {
      const item = {
        produto: {
          nome: this.produto.nome,
          id: this.produto.id,
          icone: this.produto.icone,
          quantidade: 1,
          plano: {
            id: plano.id,
            valor: plano.valor,
            descricao: plano.descricao,
            item_planos: this.obterItemPlano(plano)
          }
        }
      }
      this.ActionAdicionarItemCarrinho(item)
    },

    async efetuarAceiteContrato (plano) {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        this.adicionarItemCarrinho(plano)
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaComunicacaoServidor)
      }
      this.definirFlagCarregandoDados(false, '')
    },
    tratarAposSalvarRegistro () {
      if (this.retorno.sucesso) {
        util.criarAlertaToastDeSucesso(this, 'Aviso', this.retorno.mensagem)
        this.$bvModal.hide('modalContratarProduto')
        const dadosRetornoContrato = this.retorno.listaDados
        this.$emit('contratoConfirmado', dadosRetornoContrato)
      } else {
        util.criarAlertaToastDeErro(this, 'Aviso', this.retorno.mensagem)
      }
    },
    validarDadosFormulario () {
      this.resetarListaDeErros()
      const formulario = util.mapearObjetos(this.formulario, {})
      if (formulario.aceite_termos === false) {
        this.retorno.listaDeErros['aceite_termos'] = 'Este campo é obrigatório'
      }
      if (this.planoSelecionado === null) {
        this.retorno.listaDeErros['plano'] = 'Este campo é obrigatório'
      }
      const validacaoOk = Object.values(this.retorno.listaDeErros).length === 0
      return validacaoOk
    },
    resetarDados () {
      this.formulario = {
        aceite_termos: false
      }
      this.resetarListaDeErros()
    },
    tratarEventoFecharModal (bvModalEvt) {
      if (this.flagsDeControle.carregandoDados.status) {
        bvModalEvt.preventDefault()
      }

      this.$parent.abrirModal = false
    },
    resetarListaDeErros () {
      this.retorno.sucesso = false
      this.retorno.mensagem = ''
      this.retorno.listaDeErros = []
    },
    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },
    formatarValorMonetario (valor) {
      if (util.valorEhNulo(valor)) return 'R$ 0'
      return util.formatarValorMonetarioComCifrao(valor, { minimumFractionDigits: 0 })
    },

    obterItemPlano (plano) {
      return plano.item_planos.find(item => item.plano === plano.id)
    },

    obterQuantidadeItemPlano (plano) {
      const itemPlano = this.obterItemPlano(plano)
      if (util.valorEhNulo(itemPlano)) return ''
      return itemPlano.quantidade
    },

    obterNomeItemPlano (plano) {
      const itemPlano = this.obterItemPlano(plano)
      if (util.valorEhNulo(itemPlano)) return ''
      return itemPlano.nome
    },

    mascaraQuantidade () {
      this.formulario.quantidade = util.apenasNumeros(this.formulario.quantidade)
    }
  }
}
